<flx-modal
  [dismissible]="false"
  class="flex flex-col p-8 bg-neutral-800 rounded-2xl"
>
  <div
    class="flx-modal-title text-neutral-50"
    flxModalHeaderTitle
  >
    Edit Generated Data Model Keys
  </div>
  <div
    class="flx-modal-subtitle text-neutral-400"
    flxModalHeaderSubtitle
  >
    You can edit keys or opt out of generating keys for generated components
  </div>

  <div class="flex flex-col grow gap-8 h-full">
    <div class="flex flex-col gap-2 grow text-neutral-50 overflow-y-scroll">
      @for (model of dataModelItems; track $index) {
        <div
          [formGroup]="model.form"
          [class.opacity-30]="!model.form.get('active').value"
          class="has-[flx-data-model-autocomplete.error-required]:mb-8 has-[flx-data-model-autocomplete.error-wrong-type]:mb-8 flex items-center flex gap-2 align-center data-model-form"
        >
          <flx-checkbox formControlName="active" />

          <span class="w-48 text-sm text-white">{{ model.label }}</span>

          <div class="relative flex flex-1 justify-between items-center">
            <flx-data-model-autocomplete
              [formControl]="model.form.get('key')"
              [selectedTemplateConfig]="{
                componentIdentifier: model.origDataModelItem.templateConfigIdentifier,
              }"
              [class.error-required]="model.form.get('key').errors?.required"
              class="h-[26px] w-full"
              type="input"
            />

            @if (model.form.get('key').errors?.required) {
              <flx-error>Field is required</flx-error>
            }
          </div>

          <div
            [class.bg-green-800]="model.status === DataModelItemStatus.CREATED"
            [class.bg-yellow-800]="model.status === DataModelItemStatus.MAPPED"
            class="h-[26px] flex gap-1 justify-center items-center w-20 p-1 rounded capitalize text-xs"
          >
            {{ model.status }}
            <flx-icon
              [pTooltip]="statusTooltipMap[model.status]"
              name="info"
              class="opacity-30"
              tooltipPosition="top"
            />
          </div>

          <span class="w-24 px-2 py-1 text-xs lowercase"
            >{{ model.type }} {{ model.origDataModelItem.multiInstance ? '[]' : '' }}</span
          >

          <flx-input class="flex-1">
            <input
              flxInput
              placeholder="Set a description..."
              formControlName="description"
            />
          </flx-input>
        </div>
      }
    </div>

    <div class="flex grow-0 shrink-0 gap-4">
      <button
        (click)="closeModal()"
        class="flex-1 rounded border border-neutral-500 px-8 py-2 text-white text-sm text-center"
      >
        Back
      </button>
      <button
        [disabled]="!canSaveChanges()"
        (click)="saveChanges()"
        class="flex-1 rounded border border-neutral-500 px-8 py-2 text-white text-sm text-center disabled:bg-neutral-600 disabled:border-neutral-600 disabled:text-neutral-400 disabled:cursor-not-allowed"
      >
        Save & Close
      </button>
    </div>
  </div>
</flx-modal>
